var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-col",
        { attrs: { cols: "auto" } },
        [
          _c("v-dialog", {
            attrs: {
              transition: "dialog-bottom-transition",
              "max-width": "600",
            },
            scopedSlots: _vm._u([
              {
                key: "activator",
                fn: function (ref) {
                  var on = ref.on
                  var attrs = ref.attrs
                  return [
                    _c(
                      "v-btn",
                      _vm._g(
                        _vm._b(
                          { attrs: { color: "primary" } },
                          "v-btn",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [_vm._v("Toplu Sefer Güncelle")]
                    ),
                  ]
                },
              },
              {
                key: "default",
                fn: function (dialog) {
                  return [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-toolbar",
                          { attrs: { color: "primary", dark: "" } },
                          [_vm._v("Toplu Sefer Güncelleme")]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-container",
                          { attrs: { fluid: "" } },
                          [
                            _c("v-select", {
                              attrs: {
                                items: _vm.sailList,
                                label: "Seferler",
                                "item-value": "id",
                                multiple: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "selection",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "div",
                                          { staticStyle: { width: "30%" } },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(data.item.id) +
                                                " - " +
                                                _vm._s(
                                                  _vm._f("ddMMyyyy")(
                                                    data.item.sailDate
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(data.item.id) +
                                            " - " +
                                            _vm._s(
                                              _vm._f("ddMMyyyy")(
                                                data.item.sailDate
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "prepend-item",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-list-item",
                                          {
                                            attrs: { ripple: "" },
                                            on: {
                                              mousedown: function ($event) {
                                                $event.preventDefault()
                                              },
                                              click: _vm.selectAllSails,
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-action",
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      color:
                                                        _vm.selectedSails
                                                          .length > 0
                                                          ? "indigo darken-4"
                                                          : "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        mdi-checkbox-blank-outline\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    "\n                        Tümünü Seç\n                      "
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.selectedSails,
                                callback: function ($$v) {
                                  _vm.selectedSails = $$v
                                },
                                expression: "selectedSails",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-container",
                          { attrs: { fluid: "" } },
                          [_c("v-divider")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-container",
                          { attrs: { fluid: "" } },
                          [
                            _c("v-select", {
                              attrs: {
                                items: _vm.cruiseRoomList,
                                label: "Odalar",
                                "item-value": "id",
                                multiple: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "selection",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "div",
                                          { staticStyle: { width: "30%" } },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(data.item.roomNumber) +
                                                " - " +
                                                _vm._s(
                                                  _vm.getRoom(data.item.roomId)
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(data.item.roomNumber) +
                                            " - " +
                                            _vm._s(
                                              _vm.getRoom(data.item.roomId)
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "prepend-item",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-list-item",
                                          {
                                            attrs: { ripple: "" },
                                            on: {
                                              mousedown: function ($event) {
                                                $event.preventDefault()
                                              },
                                              click: _vm.selectAllCruiseRooms,
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-action",
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      color:
                                                        _vm.selectedSails
                                                          .length > 0
                                                          ? "indigo darken-4"
                                                          : "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        mdi-checkbox-blank-outline\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    "\n                        Tümünü Seç\n                      "
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-item",
                                          { attrs: { ripple: "" } },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "row" },
                                              [
                                                _c("base-edit-input", {
                                                  attrs: {
                                                    label: "Filtre",
                                                    rules: "required",
                                                  },
                                                  model: {
                                                    value: _vm.roomFilterTerm,
                                                    callback: function ($$v) {
                                                      _vm.roomFilterTerm = $$v
                                                    },
                                                    expression:
                                                      "roomFilterTerm",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.selectedCruiseRooms,
                                callback: function ($$v) {
                                  _vm.selectedCruiseRooms = $$v
                                },
                                expression: "selectedCruiseRooms",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-container",
                          { attrs: { fluid: "" } },
                          [
                            _c("v-card-text", [_vm._v("  Oda bloklama ")]),
                            _vm._v(" "),
                            _c("v-switch", {
                              attrs: {
                                label: _vm.isBlock ? "block" : "unblock",
                              },
                              model: {
                                value: _vm.isBlock,
                                callback: function ($$v) {
                                  _vm.isBlock = $$v
                                },
                                expression: "isBlock",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-container",
                          [
                            _c("v-select", {
                              attrs: {
                                items: _vm.agencyList,
                                "item-value": "id",
                                "item-text": "email",
                                label: "Rezerve edilen acente",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "selection",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "div",
                                          { staticStyle: { width: "30%" } },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(data.item.name) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(data.item.name) +
                                            "\n                "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.reservedAgencyId,
                                callback: function ($$v) {
                                  _vm.reservedAgencyId = $$v
                                },
                                expression: "reservedAgencyId",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-container",
                          { attrs: { fluid: "" } },
                          [_c("v-divider")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-container",
                          { attrs: { fluid: "" } },
                          [
                            _c("v-card-text", [_vm._v("  İşlemi zorla ")]),
                            _vm._v(" "),
                            _c("v-switch", {
                              attrs: { label: _vm.isForce ? "force" : "-" },
                              model: {
                                value: _vm.isForce,
                                callback: function ($$v) {
                                  _vm.isForce = $$v
                                },
                                expression: "isForce",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          { staticClass: "justify-end" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { text: "" },
                                on: {
                                  click: function ($event) {
                                    dialog.value = false
                                  },
                                },
                              },
                              [_vm._v("Close")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", text: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.save(dialog)
                                  },
                                },
                              },
                              [_vm._v("Save")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }